import { useId } from 'react';

/**
 * The QAAS Lab wordmark: a drawn mark plus the name.
 *
 * The mark is a four-point spark inside an orbit -- the assistant's "thinking"
 * idea, in the site's own colours. It is inline SVG so it costs no request and
 * scales cleanly.
 *
 * The gradient's two stops are the accent ramp from variables.css, written out
 * as hex because `stop-color` cannot take a custom property in every browser
 * the site supports. They are the only brand colours not declared in
 * variables.css: if the ramp changes, these two change with it.
 *
 * The gradient needs an id, and the wordmark appears in more than one place on
 * a page (header and footer), so the id comes from `useId` rather than a
 * literal: duplicate ids would make one instance's gradient reference the
 * other's.
 */
const Wordmark = ({ className = '', size = 26, showText = true }) => {
  const gradientId = `wordmark-spark-${useId().replace(/[:]/g, '')}`;

  return (
    <span className={`wordmark${className ? ` ${className}` : ''}`}>
      <svg
        className="wordmark__mark"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          <linearGradient id={gradientId} x1="4" y1="4" x2="20" y2="20">
            <stop offset="0%" stopColor="#5fc0d4" />
            <stop offset="100%" stopColor="#3fa9be" />
          </linearGradient>
        </defs>
        <circle
          cx="12"
          cy="12"
          r="9.25"
          stroke="currentColor"
          strokeOpacity="0.35"
          strokeWidth="1.2"
        />
        <path
          d="M12 3.75 13.95 9.4 19.6 11.35 13.95 13.3 12 18.95 10.05 13.3 4.4 11.35 10.05 9.4Z"
          fill={`url(#${gradientId})`}
        />
      </svg>
      {showText ? (
        <span className="wordmark__text">
          QAAS <span className="wordmark__text-accent">Lab</span>
        </span>
      ) : null}
    </span>
  );
};

export default Wordmark;
